/**
 * Web component: Customers register (customers-register)
 * -----------------------------------------------------------------------------
 * Register page section.
 * - Component settings: section / dynamic / web / vanilla
 *
 */
import '~async/utils/checkbox-input/checkbox-input.scss'
import './customers-register.scss'

import timings from '~/config/timings'
import { vueReady } from '~/core/runners'

/**
 * Create new <customers-register> custom element.
 */
class CustomersRegister extends HTMLElement {
  constructor() {
    super()

    this.nodeSelectors = {
      registerForm: this.querySelector('[js-register="form"]'),
      returnTo: this.querySelector('[name="return_to"]'),
    }
  }

  /**
   * Lifecycle hook - component is attached to the DOM.
   */
  connectedCallback() {
    if (!this.nodeSelectors.registerForm) {
      return
    }

    this.setEventListeners()
    this.checkUrlParameters()
  }

  /**
   * Set event listeners.
   */
  setEventListeners() {
    if (!cnvs.settings.notifications.register) {
      return
    }

    this.nodeSelectors.registerForm.addEventListener('submit', async(event) => {
      event.preventDefault()
      let displayUrl = cnvs.routes.root

      if (this.nodeSelectors.returnTo?.value) {
        displayUrl = this.nodeSelectors.returnTo.value
      }

      cnvs.EventBus.emit('notification:add', {
        displayUrl,
        namespace: 'login',
        text: cnvs.strings.customers.notifications.register,
        timeout: timings.message,
        type: 'success',
      })

      await cnvs.Sleep(0)
      this.nodeSelectors.registerForm.submit()
    })
  }

  /**
   * Check URL parameters to add return to meta tag.
   * - Return to URL parameter is ignored when creating new account.
   * - Required to redirect back to product activation page.
   */
  checkUrlParameters() {
    const urlParameters = new URLSearchParams(window.location.search)

    if (!urlParameters.get('return_url')) {
      return
    }

    const returnToUrl = urlParameters.get('return_url')

    if (this.nodeSelectors.returnTo) {
      this.nodeSelectors.returnTo.setAttribute('value', returnToUrl)
      return
    }

    const input = `<input type="hidden" name="return_to" value="${returnToUrl}">`
    this.nodeSelectors.registerForm.insertAdjacentHTML('beforeend', input)
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('customers-register')) {
    return
  }

  customElements.define('customers-register', CustomersRegister)
})
